import { render, staticRenderFns } from "./PageAdmin.vue?vue&type=template&id=14399676&"
import script from "./PageAdmin.vue?vue&type=script&lang=js&"
export * from "./PageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PageAdmin.vue?vue&type=style&index=0&id=14399676&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports